import {Banner} from '@primer/react'

export function FeatureBanner(props: {type: 'reload' | 'error'}) {
  let bannerText = ''
  if (props.type === 'reload') {
    bannerText = 'Changes saved! Please reload the page to view the changes.'
  } else if (props.type === 'error') {
    bannerText = 'Unable to save changes. Please try again.'
  }

  const title = props.type === 'reload' ? 'Changes saved!' : 'Error'
  const variant = props.type === 'reload' ? 'success' : 'critical'
  const primaryAction =
    props.type === 'reload' ? (
      <Banner.PrimaryAction
        aria-label="Reload the page to apply the feature preview changes"
        onClick={() => {
          window.location.reload()
        }}
      >
        Reload
      </Banner.PrimaryAction>
    ) : undefined

  if (props.type === 'reload') {
    // Ignore the reload banner for now. Re-introduce in a future update.
    return
  }

  return (
    <Banner
      title={title}
      hideTitle
      description={bannerText}
      variant={variant}
      layout="compact"
      actionsLayout="inline"
      primaryAction={primaryAction}
    />
  )
}

try{ FeatureBanner.displayName ||= 'FeatureBanner' } catch {}